export default __webpack_public_path__ + "static/media/bkm-penjualan.e16a90bd.png";